module.exports = __webpack_public_path__ + "img/title.30c0c79b.svg";